export class MockActivatedRouteSnapshot {
  data: object;
  paramMap = jasmine.createSpyObj(['get']);
}
